import { VStack } from '@/package';
import type { Task } from '@/type';

import { MyWorkTaskPeriodLabeledObject } from './MyWorkTaskPeriodLabeledObject';
import { MyWorkTaskStatisticSummary } from './MyWorkTaskStatisticSummary';
import { MyWorkTaskWorkFlowPerformance } from './MyWorkTaskWorkFlowPerformance';

const MyWorkTaskStatistics = ({ taskDetail }: { taskDetail: Task }) => {
  return (
    <VStack gap={1.5} className="h-full w-[972px] pt-4">
      <MyWorkTaskStatisticSummary taskDetail={taskDetail} />
      <MyWorkTaskWorkFlowPerformance taskDetail={taskDetail} />
      <MyWorkTaskPeriodLabeledObject taskDetail={taskDetail} />
    </VStack>
  );
};

export default MyWorkTaskStatistics;
